<su-headline h="h1" skin="primary">{{ title }} - {{ tenantName }}</su-headline>

<div class="row-chips">
  <su-chip [items]="chips" (onRemove)="handleOnRemoveChip($event)"></su-chip>
</div>

<ng-template #toolbarTpl>
  <su-slot-controls
    [mainTLabel]="'crud.filter' | translate"
    [buttons]="controlButtons"
    [chips]="chips"
    [menuItems]="menuItems"
    [dialogData]="dialogData"
    (onCloseDialog)="onCloseDialog($event)"
    [modal]="modalComponent">
  </su-slot-controls>
</ng-template>

<mtx-grid
  [columnResizable]="true"
  [columns]="columns"
  [data]="data.items"
  [length]="data.totalCount"
  [pageOnFront]="false"
  [loading]="isLoading"
  [rowStriped]="true"
  [noResultText]="noResultText"
  [pageSizeOptions]="[5, 10, 25, 50, 100]"
  [pageSize]="config.grid.paging.pageSize"
  [pageIndex]="config.grid.paging.pageIndex"
  [showPaginator]="config.grid.paging.showPaginator"
  [columnMenuButtonText]="'grid.columns_shown' | translate"
  [showSidebar]="true"
  [showToolbar]="true"
  [columnSortable]="true"
  [showColumnMenuButton]="true"
  [columnHideable]="true"
  [columnHideableChecked]="'show' | translate"
  columnMenuButtonClass="col-button"
  columnMenuButtonType="flat"
  [columnPinnable]="false"
  [toolbarTemplate]="toolbarTpl"
  (rowClick)="clickRowWrapper($event)"
  (columnChange)="columnsChanged($event)"
  (sortChange)="sortChange($event)"
  (page)="getNextPage($event)">
</mtx-grid>

<app-spinner-overlay [show]="loading" label=""></app-spinner-overlay>